export const LENGTH_0 = 0;
export const LENGTH_1 = 1;
export const LENGTH_16 = 16;
export const LENGTH_32 = 32;
export const LENGTH_64 = 64;
export const LENGTH_128 = 128;
export const LENGTH_256 = 256;
export const LENGTH_512 = 512;
export const LENGTH_1024 = 1024;